import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export default function MetricCard({
    label,
    value,
    sublabel,
    deltaPct,
    deltaLabel = "30d",
    children,
    accent = false,
    testid,
    tag,
    invertDeltaColor = false,
}) {
    const hasDelta = typeof deltaPct === "number";
    const positive = hasDelta ? deltaPct >= 0 : null;
    // When invertDeltaColor is true (e.g. churn), "up" = bad = red.
    const good = hasDelta ? (invertDeltaColor ? !positive : positive) : null;
    const DeltaIcon =
        !hasDelta ? Minus : positive ? ArrowUpRight : ArrowDownRight;

    return (
        <div
            className={`hg-card p-5 flex flex-col gap-3 ${
                accent ? "ring-1 ring-[#22C55E]/20" : ""
            }`}
            data-testid={testid}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="hg-eyebrow">{label}</div>
                {tag && (
                    <div className="hg-eyebrow text-[9px] text-[#22C55E] border border-[#22C55E]/30 px-1.5 py-0.5 rounded-sm">
                        {tag}
                    </div>
                )}
            </div>

            <div className="flex items-baseline gap-2">
                <div
                    className={`font-mono-data text-3xl md:text-4xl font-bold ${
                        accent ? "text-[#22C55E] hg-glow-sm" : "text-[#FAFAFA]"
                    }`}
                >
                    {value}
                </div>
                {sublabel && (
                    <div className="font-mono-data text-xs text-[#71717a] tracking-wider">
                        {sublabel}
                    </div>
                )}
            </div>

            {hasDelta && (
                <div className="flex items-center gap-1.5">
                    <div
                        className={`flex items-center gap-0.5 text-[11px] font-mono-data ${
                            good ? "text-[#22C55E]" : "text-[#ef4444]"
                        }`}
                    >
                        <DeltaIcon size={12} />
                        {Math.abs(deltaPct).toFixed(2)}%
                    </div>
                    <div className="hg-eyebrow text-[10px]">vs {deltaLabel}</div>
                </div>
            )}

            {children}
        </div>
    );
}
